import { lazyLoad, LazyLoadedComponent, PlatformRoute } from '~/libs/core'
import { AppSubdomain, EnvironmentConfig, ToolTitle } from '~/config'

const CampusApp: LazyLoadedComponent = lazyLoad(() => import('./CampusApp'))
const CampusHomePage: LazyLoadedComponent = lazyLoad(
    () => import('./pages/home'),
    'CampusHomePage',
)
const CampusLeaderboardPage: LazyLoadedComponent = lazyLoad(
    () => import('./pages/leaderboard'),
    'CampusLeaderboardPage',
)

export const rootRoute: string = (
    EnvironmentConfig.SUBDOMAIN === AppSubdomain.campus ? '' : `/${AppSubdomain.campus}`
)

export const toolTitle: string = ToolTitle.campus

export const campusRoutes: ReadonlyArray<PlatformRoute> = [
    {
        authRequired: true,
        children: [
            {
                // Campus program homepage listing the participating universities
                element: <CampusHomePage />,
                id: 'Campus Home',
                route: '',
            },
            {
                // Campus program leaderboard, eg. https://campus.topcoder-dev.com/mecw
                children: [],
                element: <CampusLeaderboardPage />,
                id: 'Campus Leaderboard',
                route: ':groupName',
            },
        ],
        domain: AppSubdomain.campus,
        element: <CampusApp />,
        id: toolTitle,
        route: rootRoute,
        title: toolTitle,
    },
]
